<template>
  <vs-row vs-justify="center">
    <vs-col
      type="flex"
      vs-justify="center"
      vs-align="center"
      vs-lg="12"
      vs-xs="12"
      vs-md="12"
      vs-sm="12"
    >
      <vs-card>
        <h3 class="card-title d-flex">List of Users Registered in {{CategoryName}} Category</h3>
        <p class="card-subtitle">List of all accounts with view details.</p>
        <vs-row>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Select State" v-model="state">
              <vs-select-item value="" text="Select State" disabled/>
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item,index) in states"
              />
            </vs-select>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
            <vs-select :color="colorx" label="Select City" v-model="city">
              <vs-select-item value="" text="Select City" disabled/>
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item,index) in cities"
              />
            </vs-select>
          </vs-col>
           <vs-col vs-lg="3" vs-xs="12">
           <vs-button color="primary" type="filled" class="searchBtn" @click="searchUser()">Search</vs-button>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12">
           <vs-button color="warning" type="filled" class="searchBtn" @click="reset()">Reset</vs-button>
          </vs-col>
        </vs-row>
        <br />
        <table class="table" scope="col">
          <tr>
            <th scope="col">#</th>
            <th scope="col">User Name</th>
            <th scope="col">Email Id</th>
            <th scope="col">User Type</th>
            <th scope="col"></th>
          </tr>
          <tr v-for="(item, index) in all" :key="item.name">
            <td scope="col">{{ index + 1 }}</td>
            <td scope="col">{{item.name}}</td>
            <td scope="col">{{ item.email }}</td>
            <td scope="col">
              <vs-chip color="warning">User</vs-chip>
            </td>
            <td scope="col">
              <vs-icon
                style="cursor:pointer;"
                icon="visibility"
                title="View Details"
                @click="viewDetails(item)"
              ></vs-icon>
            </td>
          </tr>
        </table>

        <!-- Code -->
        <vs-popup :title="'Details about - ' + accName" :active.sync="viewPopup">
          <vs-row>
            <vs-col vs-lg="6" vs-xs="12" class="leftHead">
              <h4>Image</h4>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="rightHead">
              <vs-avatar
                v-if="accImage == ''"
                size="50px"
                :src="require('@/assets/images/users/3.png')"
              />
              <img v-else :src="accImage" height="50px" />
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
              <h4>Name</h4>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="rightHead top">
              <h5>{{ accName }}</h5>
            </vs-col>
            <hr />
            <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
              <h4>Contact Email Id</h4>
            </vs-col>
            <vs-col vs-lg="6" vs-xs="12" class="rightHead top">
              <h5>{{ accEmail }}</h5>
            </vs-col>
            <hr />
            <vs-col vs-lg="6" vs-xs="12" class="leftHead top">
              <h4>Contact Phone</h4>
            </vs-col>
            <hr />
          </vs-row>
        </vs-popup>
        <!-- Code -->
      </vs-card>
    </vs-col>
  </vs-row>
</template>
<style scoped>
.leftHead h4 {
  font-size: 14px;
  font-weight: 600;
}
.rightHead h5 {
  font-size: 14px;
  font-weight: 400;
}
.title {
  font-size: 18px;
  font-weight: 600;
}
.top {
  margin-top: 10px;
}
.searchBtn{
  margin-top: 25px;
  width: 50%;
}
</style>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
// import router from "@/router.js";
import list from "indian-states-cities";
export default {
  name: "Users",
  data: () => ({
    colorx: "#0D2144",
    admin: {
      type: "USER"
    },
    CategoryName: "",
    states: [],
    cities: [],
    state: "",
    city: "",
    viewPopup: false,
    all: [],
    addAdmin: false,
    accName: "",
    accEmail: "",
    accPhone: "",
    accImage: ""
  }),
  computed: {},
  methods: {
    fetchAllAccounts() {
      this.$vs.loading();
      api
        .post(API.GET_USER_BY_CATEGORY_GUID, {
          categoryGuid: this.$route.params.catId
        })
        .then(r => {
          if (r.data.data.count == 0 || r.data.data.rows.length == 0) {
            this.$router.push("/category");
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Data Not Found",
              text: "No Users Found for the Category",
              color: "danger",
              position: "top-right"
            });
          } else {
            this.$vs.loading.close();
            this.$data.all = r.data.data.rows;
            this.$data.CategoryName = r.data.data.rows[0].categoryObject.name;
          }
        })
        .catch(() => {});
    },
    viewDetails(i) {
      this.$data.viewPopup = true;
      this.$data.accName = i.name;
      this.$data.accPhone = i.phone;
      this.$data.accImage = i.image;
      this.$data.accEmail = i.email;
    },
    searchUser(){
      this.$vs.loading();
      let req = {};
      req.state = this.state;
      req.city = this.city;
       api
        .post(API.SEARCH_USERS_BY_CITY_STATE, req)
        .then(r => {
          if (r.data.status) {
            this.$vs.loading.close();
            this.$data.all = r.data.data;
          } 
          else if(!r.data.status && r.data.message == 'ERROR_DATA_NOT_FOUND'){
            this.$vs.loading.close();
            this.$data.all = [];
            this.$vs.notify({
              title: "Data Error",
              text: r.data.error,
              color: "danger",
              position: "top-right"
            })
          }else{
            this.$vs.loading.close();
            this.$vs.notify({
              title: "Data Error",
              text: r.data.error,
              color: "danger",
              position: "top-right"
            })
          }
        })
        .catch(() => {});
    },
    reset(){
      this.fetchAllAccounts();
      this.$data.state = "";
      this.$data.city = "";
    }
  },
  watch: {
    state(newVal){
      this.$data.city = "";
      this.cities = list.citiesForState(newVal);
    }
  },
  created() {
    this.fetchAllAccounts();
    this.$data.states = list.allStates();
    this.$data.cities = list.citiesForState(this.$data.state);
  }
};
</script>
